import React from 'react'

import { OverlayLoaderProvider } from 'context/OverlayLoaderContext'
import withErrorBoundary from 'hoc/withErrorBoundary'
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom'

const PaymentAndroidCheckout = React.lazy(
  () => import('components/PaymentAndroidCheckout')
)

const MVSGiveaway = React.lazy(() => import('components/MVSGiveaway'))

const SuperYoddhaGiveaway = React.lazy(
  () => import('components/SuperYoddhaGiveaway')
)

const AboutUs = React.lazy(() => import('components/AboutUs'))
const ContactUs = React.lazy(() => import('components/ContactUs'))
const SuperFans = React.lazy(() => import('components/SuperFans'))
const ImproveSkills = React.lazy(() => import('components/ImproveSkills'))

const SecurityAdvicePolicy = React.lazy(
  () => import('components/SecurityAdvicePolicy')
)

const PrivacyPolicy = React.lazy(() => import('components/PrivacyPolicy'))

const CookiePolicy = React.lazy(() => import('components/CookiePolicy'))

const Copyright = React.lazy(() => import('components/CopyRight'))

const TermsConditions = React.lazy(() => import('components/TermsAndCondition'))

const MiniSeries = React.lazy(() => import('components/MiniSeries'))

const LoyaltyProgramPro = React.lazy(
  () => import('components/LoyaltyProgramPro')
)
const LoyaltyProgramAnnual = React.lazy(
  () => import('components/LoyaltyProgramAnnual')
)

const Root = React.lazy(() => import('./components/Root'))

const PocketVipPlans = React.lazy(() => import('./components/PocketVipPlans'))
const PaymentForm = React.lazy(
  () => import('./components/PaymentFormComponent')
)
const StandalonePaymentForm = React.lazy(
  () => import('./components/StandalonePaymentFormComponent')
)
const PaymentSuccess = React.lazy(() => import('./components/PaymentSuccess'))
const PaymentFail = React.lazy(() => import('./components/PaymentFail'))
const RenewPocketVip = React.lazy(
  () => import('./components/RenewPocketVipComponent')
)
const PrimeUnlocked = React.lazy(
  () => import('./components/PrimeUnlockedComponent')
)
const HomeIOS = React.lazy(() => import('./components/HomeIOS'))
const PaypalCheckout = React.lazy(() => import('./components/PaypalCheckout'))
const PiggyBankFAQs = React.lazy(() => import('./components/PiggyBankFaqs'))
const LuckyDraw = React.lazy(() => import('./components/LuckyDraw/LuckyDraw'))
const OfferWall = React.lazy(() => import('./components/OfferWall'))
const OfferWallRewamp = React.lazy(() => import('./components/OfferWallRewamp'))
const RewardStatus = React.lazy(
  () => import('./components/OfferWall/RewardStatus')
)
const BattlePass = React.lazy(() => import('./components/BattlePass'))
const CouponOffer = React.lazy(() => import('./components/CouponOffer'))
const Success = React.lazy(() => import('./components/CouponOffer/Success'))
const CouponOfferPartnership = React.lazy(
  () => import('./components/CouponOffer/CouponOfferPartnership')
)
const HelpSupport = React.lazy(() => import('./components/HelpSupport'))
const OfferSuccess = React.lazy(
  () => import('./components/CouponOffer/OfferSuccess')
)
const StripeCheckout = React.lazy(() => import('./components/StripeCheckout'))
const StripeSuccess = React.lazy(
  () => import('./components/StripeCheckout/StripeSuccess')
)
const StripeOptimisedSuccess = React.lazy(
  () => import('./components/StripeOptimizedCheckoutFM/StripeSuccess')
)

const VoiceOverImpact = React.lazy(() => import('components/VoiceOverImpact'))

const StripeCheckoutFm = React.lazy(
  () => import('./components/StripeCheckoutFm')
)
const StripeOptimisedCheckoutFm = React.lazy(
  () => import('./components/StripeOptimizedCheckoutFM')
)
const StripeInAppCheckoutFm = React.lazy(
  () => import('./components/StripeInAppCheckoutFm')
)
const StripeInAppSuccessFm = React.lazy(
  () => import('./components/StripeInAppCheckoutFm/StripeInAppSuccess')
)
// const StripeAndroidFm = React.lazy(() =>
//   import("./components/StripeAndroidFm")
// );
const StripeAndroidSuccessFm = React.lazy(
  () => import('./components/StripeAndroidFm/StripeAndroidSuccess')
)
const PaypalCheckoutFm = React.lazy(
  () => import('./components/PaypalCheckoutFm')
)
const JuspayCheckoutFm = React.lazy(
  () => import('./components/JuspayCheckoutFm')
)
const StripeCheckoutWalletFm = React.lazy(
  () => import('./components/StripeWallet')
)
const StripeSuccessFm = React.lazy(
  () => import('./components/StripeCheckoutFm/StripeSuccess')
)
const PaypalSuccessFm = React.lazy(
  () => import('./components/PaypalCheckoutFm/PaypalSuccess')
)
const JuspaySuccessFm = React.lazy(
  () => import('./components/JuspayCheckoutFm/JuspaySuccess')
)
const CoinGuide = React.lazy(() => import('./components/CoinGuide/CoinGuide'))
const StripeSaveCardCheckout = React.lazy(
  () => import('./components/StripeSaveCardCheckoutFm')
)
const VideoCoinGuide = React.lazy(
  () => import('./components/VideoCoinGuide/VideoCoinGuide')
)
const AppleFile = React.lazy(() => import('./components/AppleFile/AppleFile'))
const LoyaltyProgram = React.lazy(() => import('./components/LoyaltyProgram'))
const ShowPassPack = React.lazy(
  () => import('./components/ShowPassPack/ShowPassPack')
)
const DailyPassPack = React.lazy(
  () => import('./components/DailyPassPack/DailyPassPack')
)
const LoyaltyProgramNovel = React.lazy(
  () => import('./components/LoyaltyProgramNovel')
)
const AccountClosure = React.lazy(() => import('./components/AccountClosure'))
const NotFound = React.lazy(() => import('./components/NotFound'))
const RootBoundary = React.lazy(() => import('./components/RootBoundary'))
const ShowStreaks = React.lazy(
  () => import('./components/ShowStreaks/ShowStreaks')
)
const StudentPass = React.lazy(() => import('./components/StudentPass'))

const UserSubscriptionDetails = React.lazy(
  () => import('components/UserSubscriptionDetails')
)

const DailyUnlockingSubFAQs = React.lazy(
  () => import('components/DailyUnlockingSubFaq')
)

const BillingInfo = React.lazy(() => import('components/BillingInfo'))
const Checkout = React.lazy(() => import('components/Checkout'))
const IOSPaymentDesision = React.lazy(
  () => import('components/IOSPaymentDesision')
)

const IncentReward = React.lazy(() => import('components/IncentReward'))

const RewardSlotMachine = React.lazy(
  () => import('./components/RewardSlotMachine')
)

const StoryCards = React.lazy(() => import('./components/StoryCards'))

const allRoutes = [
  {
    path: '/',
    element: <Root />,
  },
  {
    path: '/payment-android-checkout',
    element: (
      <OverlayLoaderProvider>
        <PaymentAndroidCheckout />
      </OverlayLoaderProvider>
    ),
  },
  {
    path: '/pocket_vip_plans',
    element: <PocketVipPlans />,
  },
  {
    path: '/student_pass',
    element: <StudentPass />,
  },
  {
    path: '/payment_form',
    element: <PaymentForm />,
  },
  {
    path: '/standalone_payment_form',
    element: <StandalonePaymentForm />,
  },
  {
    path: '/payment_success',
    element: <PaymentSuccess />,
  },
  {
    path: '/payment_failure',
    element: <PaymentFail />,
  },
  {
    path: '/renew_pocket_vip',
    element: <RenewPocketVip />,
  },
  {
    path: '/main_page_ios',
    element: <HomeIOS />,
  },
  {
    path: '/paypal_checkout',
    element: <PaypalCheckout />,
  },
  {
    path: '/prime_locked',
    element: <PocketVipPlans />,
  },
  {
    path: '/prime_unlocked/profile/:profile_uid',
    element: <PrimeUnlocked />,
  },
  {
    path: '/piggy_bank_faqs',
    element: <PiggyBankFAQs />,
  },
  {
    path: '/address-form',
    element: <LuckyDraw />,
  },
  {
    path: '/lucky-draw-campaign',
    element: <Navigate to="/" replace />,
  },
  {
    path: '/offer-wall',
    element: <OfferWall />,
  },
  {
    path: '/offerwall-revamp',
    element: <OfferWallRewamp />,
  },
  {
    path: '/incent-reward',
    element: <IncentReward />,
  },
  {
    path: '/rewards',
    element: <RewardStatus />,
  },
  {
    path: '/battle-pass',
    element: <BattlePass />,
  },
  {
    path: '/coupon-offer',
    element: <CouponOffer />,
  },
  {
    path: '/coupon-offer-partnership',
    element: <CouponOfferPartnership />,
  },
  {
    path: '/offer-success',
    element: <OfferSuccess />,
  },
  {
    path: '/coupon-offer-success',
    element: <Success />,
  },
  {
    path: '/help-support',
    element: <HelpSupport />,
  },
  {
    path: '/stripe-checkout',
    element: <StripeCheckout />,
  },
  {
    path: '/stripe-success',
    element: <StripeSuccess />,
  },
  {
    path: '/stripe-checkout-fm',
    element: <StripeCheckoutFm />,
  },
  {
    path: '/stripe-optimised-checkout-fm',
    element: <StripeOptimisedCheckoutFm />,
  },
  {
    path: '/stripe-inapp-checkout-fm',
    element: <StripeInAppCheckoutFm />,
  },
  {
    path: '/stripe-inapp-success-fm',
    element: <StripeInAppSuccessFm />,
  },
  {
    path: '/paypal-checkout-fm',
    element: <PaypalCheckoutFm />,
  },
  {
    path: '/juspay-checkout',
    element: <JuspayCheckoutFm />,
  },
  {
    path: '/stripe-wallet-checkout-fm',
    element: <StripeCheckoutWalletFm />,
  },
  {
    path: '/stripe-save-card-checkout-fm',
    element: <StripeSaveCardCheckout />,
  },
  {
    path: '/stripe-success-fm',
    element: <StripeSuccessFm />,
  },
  {
    path: '/stripe-optimised-success-fm',
    element: <StripeOptimisedSuccess />,
  },
  // {
  //   path: "/stripe-android-checkout-fm", //This is no longer used
  //   element: <StripeAndroidFm />,
  // },
  {
    path: '/stripe-android-success-fm',
    element: <StripeAndroidSuccessFm />,
  },
  {
    path: '/paypal-success-fm',
    element: <PaypalSuccessFm />,
  },
  {
    path: '/juspay-success',
    element: <JuspaySuccessFm />,
  },
  {
    path: '/coin-guide',
    element: <CoinGuide />,
  },
  {
    path: '/video-coin-guide',
    element: <VideoCoinGuide />,
  },
  {
    path: '/loyalty-program',
    element: <LoyaltyProgram />,
  },
  {
    path: '/account-closure',
    element: <AccountClosure />,
  },
  {
    path: '/loyalty-program-novel',
    element: <LoyaltyProgramNovel />,
  },
  {
    path: '/loyalty-program-pro',
    element: <LoyaltyProgramPro />,
  },
  {
    path: '/loyalty-program-annual',
    element: <LoyaltyProgramAnnual />,
  },
  {
    path: '/.well-known/apple-developer-merchantid-domain-association',
    element: <AppleFile />,
  },
  {
    path: '/show-pass-pack',
    element: <ShowPassPack />,
  },
  {
    path: '/daily-pass-pack',
    element: <DailyPassPack />,
  },
  {
    path: '/show-streaks',
    element: <ShowStreaks />,
  },
  {
    path: '/user-subscription-details',
    element: <UserSubscriptionDetails />,
  },
  {
    path: '/daily-unlocking-subscription-faqs',
    element: <DailyUnlockingSubFAQs />,
  },
  {
    path: '/mini-series',
    element: <MiniSeries />,
  },
  {
    path: '/superfans',
    element: <SuperFans />,
  },
  {
    path: '/copyright',
    element: <Copyright />,
  },
  {
    path: '/terms-and-conditions',
    element: <TermsConditions />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />,
  },
  {
    path: '/cookie-policy',
    element: <CookiePolicy />,
  },
  {
    path: '/security-advice-policy',
    element: <SecurityAdvicePolicy />,
  },
  {
    path: '/contact-us',
    element: <ContactUs />,
  },
  {
    path: '/about-us',
    element: <AboutUs />,
  },
  {
    path: '/voice_over_impact',
    element: <VoiceOverImpact />,
  },
  {
    path: '/improve-skills',
    element: <ImproveSkills />,
  },
  {
    path: '/billing-info',
    element: (
      <OverlayLoaderProvider>
        <BillingInfo />
      </OverlayLoaderProvider>
    ),
  },
  {
    path: '/ios-payment-decision',
    element: <IOSPaymentDesision />,
  },
  {
    path: '/checkout',
    element: (
      <OverlayLoaderProvider>
        <Checkout />
      </OverlayLoaderProvider>
    ),
  },
  {
    path: '/mvs-giveaway',
    element: <MVSGiveaway />,
  },
  {
    path: '/super-yoddha-giveaway',
    element: <SuperYoddhaGiveaway />,
  },
  {
    path: '/reward-slot-machine',
    element: <RewardSlotMachine />,
  },
  {
    path: '/story-cards',
    element: <StoryCards />,
  },
  {
    path: '/404',
    element: <NotFound />,
  },
  {
    path: '*',
    element: <Navigate replace to="/404" />,
  },
]

const router = createBrowserRouter(
  withErrorBoundary(allRoutes, <RootBoundary />)
)

function Router() {
  return <RouterProvider router={router} />
}

export default Router
